/**
 * Rendert den Förderstufen-Text als JSX; die Berechnung der Stufen liegt in
 * `@core/business-logic` (`scaleVotesToProgress`, `findNextFundingStageIndex`).
 */
export const fundingMessage = (upcomingThresholdIndex, fundingStages) => {
    function formatNumber(number) {
        return new Intl.NumberFormat('de-DE').format(number);
    }

    let currentFundingGoalText = '...';
    let threshold;
    let increment;
    let totalFund = fundingStages
        .filter((s) => upcomingThresholdIndex === -1 || s.threshold < fundingStages[upcomingThresholdIndex].threshold)
        .reduce((a, b) => a + b.increment, 0);

    if (upcomingThresholdIndex === -1) {
        // fully funded
        currentFundingGoalText = (
            <small className="text-muted">Glückwunsch: {formatNumber(totalFund)} Euro Förderung gesichert!</small>
        );
    } else if (upcomingThresholdIndex === 0) {
        // Not funded yet
        threshold = fundingStages[0].threshold;
        increment = fundingStages[0].increment;
        currentFundingGoalText = (
            <small className="text-muted">
                {formatNumber(threshold)} Stimmen knacken und {formatNumber(increment)} Euro sichern!
            </small>
        );
    } else {
        threshold = fundingStages[upcomingThresholdIndex].threshold;
        increment = fundingStages[upcomingThresholdIndex].increment;
        currentFundingGoalText = (
            <small className="text-muted">
                {formatNumber(threshold)} Stimmen knacken und weitere {formatNumber(increment)} Euro sichern!
            </small>
        );
    }
    return currentFundingGoalText;
};

export const findNextFundingStageIndex = (voteCount, fundingStages) => {
    let upcomingThreshold = Infinity;
    let upcomingThresholdIndex = -1;

    for (let i = 0; i < fundingStages.length; i++) {
        const { threshold } = fundingStages[i];
        if (threshold > voteCount && threshold < upcomingThreshold) {
            upcomingThreshold = threshold;
            upcomingThresholdIndex = i;
        }
    }
    return upcomingThresholdIndex;
};
